module.exports = __webpack_public_path__ + "img/ventas-checked.a1edbe78.png";